import PropTypes from "prop-types";
import Text from "components/shared/stays/Text";
import styles from "components/stay/Overview.module.scss";

export default function Overview({
  accommodation = "",
  city = "",
  country = "",
  duration = "",
}) {
  return (
    <div className={styles.component}>
      <div className={styles.grid}>
        {country && (
          <div>
            <Text size={3} mono className={styles.label}>
              Location
            </Text>
            <Text className={styles.info}>
              <a href="#location">
                {city && `${city}, `}
                {country}
              </a>
            </Text>
          </div>
        )}
        {duration && (
          <div>
            <Text size={3} mono className={styles.label}>
              Duration
            </Text>
            <Text className={styles.info}>{duration}</Text>
          </div>
        )}
        {accommodation && (
          <div>
            <Text size={3} mono className={styles.label}>
              Accommodation
            </Text>
            <Text className={styles.info}>{accommodation}</Text>
          </div>
        )}
      </div>
    </div>
  );
}

Overview.propTypes = {
  accommodation: PropTypes.string,
  city: PropTypes.string,
  country: PropTypes.string,
  duration: PropTypes.string,
};
